import { FiltersI, OperatorsListI, OperatorsSubListI } from '../interfaces/filters';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { getOperators, getSubOperators } from '../services/filtersService';
import dayjs from 'dayjs';
import { RootState } from './store';


const initialState: FiltersI = {
  priority: '0',
  operatorList: [],
  operatorSubList: [],
  questionStatus: '0',
  firstDate: '',
  lastDate: dayjs().format('YYYY.MM.DD'),
  typeSearch: '0',
  searchQuery: '',
  term: '0',
  source: '0',
  operator_id: '0',
  operator_sub_id: '0',
  quesTheme: '0',
};

const filtersSlice = createSlice({
  name: 'filters',
  initialState,
  reducers: {
    updateStateFilters: <K extends keyof FiltersI>(
      state: FiltersI,
      action: PayloadAction<{ key: K; value: FiltersI[K] }>
    ) => {
      state[action.payload.key] = action.payload.value;
    },

    resetFilters: (state) => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(
        getOperators.fulfilled,(state, action: PayloadAction<Array<OperatorsListI>>) => {
          state.operatorList = action.payload;
        }
      )
      .addCase(
        getSubOperators.fulfilled,(state, action: PayloadAction<Array<OperatorsSubListI>>) => {
          state.operatorSubList = action.payload;
        }
      );
  },
});


const { actions, reducer } = filtersSlice;
export default reducer;
export const { updateStateFilters, resetFilters } = actions;

export const selectFilters = (state: RootState) => state.filters;